



































































import Vue from 'vue'
import { SetEmployeePasswordPayload, ChangeEmployeePasswordPayload } from '@/types/payload'
import { CompanyEmployee } from '@/model/company/CompanyEmployee'
import { CurrentUser } from '@/model/CurrentUser'
import { SET_EMPLOYEE_PASSWORD, CHANGE_EMPLOYEE_PASSWORD } from '@/store/action-types'
import { ResponseBase } from '@/types/service-response'

interface ComponentData {
  password: string
  repeatPassword: string
  checkbox: boolean
  characters: boolean
  smallLetter: boolean
  capitalLetter: boolean
  number: boolean
  repeatPasswordValid: boolean
  showSnackbar: boolean
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  setPasswordRules: Array<(v: string) => string | boolean>
  setRepeatPasswordRules: Array<(v: string) => string | boolean>
}

export default Vue.extend({
  name: 'Password',

  props: {
    currentUser: {
      type: Object as () => CurrentUser
    },
    employeeItem: {
      type: Object as () => CompanyEmployee
    },
  },

  data (): ComponentData {
    return {
      password: '',
      repeatPassword: '',
      checkbox: false,
      characters: false,
      smallLetter: false,
      capitalLetter: false,
      number: false,
      repeatPasswordValid: false,
      setPasswordRules: [
        v => !!v ,
        //@ts-ignore
        v => this.hasCharacters(v),
        //@ts-ignore
        v => this.hasLowerCase(v),
        //@ts-ignore
        v => this.hasUpperCase(v),
        //@ts-ignore
        v => this.hasNumber(v) 
      ],
      setRepeatPasswordRules: [
        v => !!v ,
        //@ts-ignore
        v => this.comparePassword(v)
      ],
      showSnackbar: false,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
    }
  },

  watch: {
    password(newVal: string): void {
      if(this.hasCharacters(newVal)){
        this.characters = true
      } else {
        this.characters = false
      }
      if(this.hasLowerCase(newVal)){
        this.smallLetter = true
      } else {
        this.smallLetter = false
      }
      if(this.hasUpperCase(newVal)){
        this.capitalLetter = true
      } else {
        this.capitalLetter = false
      }
      if(this.hasNumber(newVal)){
        this.number = true
      } else {
        this.number = false
      }
      if(newVal === this.repeatPassword){
        this.repeatPasswordValid = true
      } else {
        this.repeatPasswordValid = false
      }
    },
    repeatPassword(newVal: string): void {
      if(newVal === this.password){
        this.repeatPasswordValid = true
      } else {
        this.repeatPasswordValid = false
      }
    },
    currentUser(newVal: CurrentUser): void {
      if(newVal) {
        const form: any = this.$refs['form']
        form.reset()
        this.checkbox = false
      }
    },
    employeeItem(newVal: CompanyEmployee): void {
      if(newVal) {
        const form: any = this.$refs['form']
        form.reset()
        this.checkbox = false
      }
    },
  },

  computed: {
    comparePasswordValid(): boolean {
      if(this.repeatPassword && this.repeatPassword.length > 0 && this.repeatPasswordValid) {
        return true
      } else {
        return false
      }
    },
    comparePasswordInvalid(): boolean {
      if(this.repeatPassword && this.repeatPassword.length > 0 && !this.repeatPasswordValid) {
        return true
      } else {
        return false
      }
    },
    canChangePassword(): boolean {
      if(this.employeeItem || this.currentUser.changePassword){
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    hasCharacters(str: string): boolean {
      if(str && str.length >= 8) {
        return true
      } else {
        return false
      }
    },

    hasLowerCase(str: string): boolean {
      if(str){
        return (/[a-z]/.test(str))
      } else {
        return false
      }
    },

    hasUpperCase(str: string): boolean {
      if(str){
        return (/[A-Z]/.test(str))
      } else {
        return false
      }
    },

    hasNumber(str: string): boolean {
      if(str){
        return (/[0-9]/.test(str))
      } else {
        return false
      }
    },

    comparePassword(str: string): boolean {
      if(str === this.password) {
        return true
      } else {
        return false
      }
    },

    async setEmployeePassword(): Promise<void>{
      const payload: SetEmployeePasswordPayload = {
        password: this.password,
        changePassword: this.checkbox,
        shortName: this.employeeItem.shortName,
        }
      try {
        await this.$store.dispatch(SET_EMPLOYEE_PASSWORD, payload)
        this.showSuccessSnackbar = true
        const form: any = this.$refs['form']
        form.reset()
        this.checkbox = false
      } catch(e) {
        this.showErrorSnackbar = true
      }
    },

    async changeEmployeePassword(): Promise<void>{
      const payload: ChangeEmployeePasswordPayload = {
        password: this.password,
        id: this.currentUser.id,
        initials: this.currentUser.initials,
        }
      try {
        const response: ResponseBase = await this.$store.dispatch(CHANGE_EMPLOYEE_PASSWORD, payload)
        if(response && !response.IsError) {
          this.showSuccessSnackbar = true
          const form: any = this.$refs['form']
          form.reset()
          this.checkbox = false
        } else {
          this.showErrorSnackbar = true
        }
      } catch(e) {
        this.showErrorSnackbar = true
      }
    },

    onSaveButtonClick(): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        if(this.employeeItem){
          this.setEmployeePassword()
        }
        if(this.currentUser){
          this.changeEmployeePassword()
        } 
      } else {
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 100)
  }

})
